import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class ExpSumNotExceededForEachStackGroupValidator extends BaseValidator {
    private expMaxPercent: number = 100;
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;

        const firstGroupItems = stacking.getFirstGroupItems();
        const firstGroupExpSum = this.calcExpSumForItems(firstGroupItems);

        if (firstGroupExpSum > this.expMaxPercent) {
            this.addError(this.getErrorMessage(1));
            return;
        }

        const secondGroupItems = stacking.getSecondGroupItems();
        const secondGroupExpSum = this.calcExpSumForItems(secondGroupItems);

        if (secondGroupExpSum > this.expMaxPercent) {
            this.addError(this.getErrorMessage(2));
        }
    }

    private calcExpSumForItems(items): number {
        let expSum = 0;
        for (let item of items) {
            expSum += Number(item.expMin);
        }

        return expSum;
    }

    private getErrorMessage(stackNumber: number): string {
        return `The total exposure in the controlled by name stack ${stackNumber} exceeds ${this.expMaxPercent}%, please decrease.`;
    }
}

export default ExpSumNotExceededForEachStackGroupValidator;
